import React, { useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import "../App.css";

export default function Payment() {
    const [show, setShow] = useState(false);
    const [success, setSuccess] = useState(false);
    const [ErrorMessage, setErrorMessage] = useState("");
    const [orderID, setOrderID] = useState(false);

    // creates a paypal order
    const createOrder = (data, actions) => {
        return actions.order
            .create({
                purchase_units: [
                    {
                        description: "PQE-2023 Registration Fee",
                        amount: {
                            currency_code: "USD",
                            value: 495,
                        },
                    },
                ],
                // not needed if a shipping address is actually needed
                application_context: {
                    shipping_preference: "NO_SHIPPING",
                },
            })
            .then((orderID) => {
                setOrderID(orderID);
                return orderID;
            });
    };

    // check Approval
    const onApprove = (data, actions) => {
        return actions.order.capture().then(function (details) {
            const { payer } = details;
            setSuccess(true);
        });
    };
    //capture likely error
    const onError = (data, actions) => {
        setErrorMessage("An Error occured with your payment ");
    };
    return (
        <PayPalScriptProvider
            options={{
                "client-id":"Aa1JbUkQ4k56rVh9-qldvJrchXDwdJ4ME0Sl3xiTvOFLGhx-9irUIpmxSCxqG_1lKQbDg_x1-kCVyw_E",
            }}
        >
            <div className={'payWrap1'}>
                <div className="paymentWrapper">
                    <div className="product-img">

                    </div>
                    <div className="product-info">
                        <h1 className={'payHeader'}>PQE-2023 Registration Fee</h1>
                        <div className="product-text">

                           <h2 className={'payInfo'}>The conference fee for the PQE-2023 conference will be $495 prepaid and $545 after january 1st.</h2>
                        </div>

                        <div className="product-price-btn">

                                <span> <h3>current price: $495 </h3></span>

                            <button type="submit" onClick={() => setShow(true)}>
                                Pay Conference Fee
                            </button>
                        </div>
                    </div>
                </div>

                {show ? (
                    <PayPalButtons
                        style={{ layout: "vertical" }}
                        createOrder={createOrder}
                        onApprove={onApprove}
                    />
                ) : null}
            </div>
        </PayPalScriptProvider>
    );
}